export default {
  routes: [
    {
      name: 'insurances',
      path: '/directory/insurances',
      component: () => import('./views/TheInsurancesTypes.vue'),

    },

    {
      name: 'insurance',
      path: '/directory/insurances/:uuid',
      component: () => import('./views/TheInsurancesType.vue'),
    },
  ]
}
